<template>
  <li>
    <span class="tree-item" :data-node-id="node.intId">
      <div class="quiz-type-indicator">
        <div class="d-flex align-center">
          <v-icon v-if="node.data.type === 'question'" class="quiz-type-indicator--question mr-2">mdi-help</v-icon>
          <v-icon v-else-if="node.data.type === 'answer'" class="quiz-type-indicator--answer mr-2">mdi-message</v-icon>
          <v-icon v-else class="quiz-type-indicator--destination mr-2">mdi-flag-checkered</v-icon>

          <span v-if="node.data.type === 'question'">Question</span>
          <span v-if="node.data.type === 'answer'"
            >Answer
            <!-- Just so it's clear what is the order of the answers -->
            <span v-if="node.data.type === 'answer'">{{ index + 1 }}</span>
          </span>
          <span v-if="node.data.type === 'destination'">Destination </span>
        </div>
      </div>
      <!--- Actions -->
      <div class="actions-wrapper">
        <template v-if="false">
          <div
            v-if="parent"
            ref="draggable"
            class="drag-item panzoom-ignore"
            draggable
            @dragstart="dragStart"
            @dragend="dragEnd">
            <v-icon class="mt-n1" color="error"> mdi-cursor-move</v-icon>
          </div>
        </template>
        <div v-if="node.data.type === 'answer'" @click="copyNode">
          <v-icon>mdi-dock-window</v-icon>
        </div>
        <div v-if="parent" @click="removeNode">
          <v-icon>mdi-trash-can-outline</v-icon>
        </div>
      </div>
      <!--- Actions END -->

      <div>
        <QuizQuestion ref="question" v-if="node.data.type === 'question'" :node.sync="node" :tree="tree"></QuizQuestion>
        <QuizAnswer v-if="node.data.type === 'answer'" :node.sync="node" :tree="tree"></QuizAnswer>
        <QuizDestination v-if="node.data.type === 'destination'" :node.sync="node" :tree="tree"></QuizDestination>
      </div>

      <div
        ref="dropzone"
        class="drop-zone"
        :class="{ invisible: !allowDestinationDrop && !allowAnswerDrop && !allowQuestionDrop }"
        @dragover="dragOver"
        @dragenter="dragEnter"
        @dragleave="dragLeave"
        @drop="drop"></div>
    </span>
    <ul v-if="node.children && node.children.length">
      <QuizTreeNode
        v-for="(child, index) in node.children"
        ref="children"
        :key="child.intKey"
        :node="child"
        :parent.sync="node"
        :tree="tree"
        :drag-data="dragData"
        @openModal="$emit('openModal', $event)"
        @item-drag-start="emitItemDragStart"
        @item-drop="emitItemDrop"
        @item-drag-end="emitItemDragEnd"
        :index="index"></QuizTreeNode>
    </ul>
  </li>
</template>

<script>
  import QuizQuestion from "./QuizQuestion.vue";
  import QuizAnswer from "./QuizAnswer.vue";
  import QuizDestination from "./QuizDestination.vue";

  /* eslint-disable */
  export default {
    name: "QuizTreeNode",
    components: { QuizAnswer, QuizQuestion, QuizDestination },
    props: {
      node: {
        type: Object,
        required: true,
      },
      tree: {
        type: Object,
        required: true,
      },
      parent: {
        type: Object || null,
      },
      dragData: {
        type: Object,
        default: () => ({}),
      },
      index: {
        type: Number,
        default: 0,
      },
    },
    emits: ["openModal"],
    computed: {
      allowDestinationDrop() {
        if (this.dragData?.currentlyDraggedNode?.data?.type === "destination") {
          if (this.node.data.type === "destination" || this.node.data.type === "question") return false;

          return true;
        }
      },
      allowAnswerDrop() {
        if (this.dragData?.currentlyDraggedNode?.data?.type === "answer") {
          if (this.node.data.type === "answer" || this.node.data.type === "destination") return false;

          return true;
        }
      },
      allowQuestionDrop() {
        if (this.dragData?.currentlyDraggedNode?.data?.type === "question") {
          if (this.node.data.type === "question" || this.node.data.type === "destination") return false;

          return true;
        }
      },
    },
    methods: {
      copyNode() {
        this.tree.copyToRight(this.parent, this.node);
      },
      removeNode() {
        if (this.node.children.length > 0) {
          this.$emit("openModal", {
            title: "Warning!",
            subtitle: "All the items below will be deleted!",
            ctaText: "Delete",
            delete: true,
            index: this.index,
            parent: this.parent,
            node: this.node,
          });
        } else {
          this.tree.removeNode(this.parent, this.node);
        }
      },
      // Edit at your own risk
      updateTreeContent(children, ref) {
        let index = ref?.index ? ref.index : 0;
        if (children[index].type === "question" && ref && ref.$refs.question) {
          ref.$refs.question.updateContent(children[index].content);
          if (children[index].children?.length > 0 && ref.$refs.children) {
            this.updateTreeContent(children[index].children, ref.$refs.children[index]);
          }
        }
      },
      dragEnter() {
        this.$refs.dropzone?.classList.add("drop-zone--active");
      },
      dragLeave() {
        this.$refs.dropzone?.classList.remove("drop-zone--active");
      },
      dragOver(e) {
        e.preventDefault();
      },
      drop(e) {
        e.preventDefault();
        this.$refs.dropzone?.classList.remove("drop-zone--active");
        this.emitItemDrop(this.node);
      },
      dragStart(e) {
        e.dataTransfer.dropEffect = "move";
        e.dataTransfer.effectAllowed = "move";
        this.$refs.draggable?.classList.add("drag-item--dragging");
        this.emitItemDragStart(this.node);
      },
      dragEnd(e) {
        this.$refs.draggable?.classList.remove("drag-item--dragging");
        this.emitItemDragEnd();
      },
      /**
       * Emits are required since the component is recursive, so in order to emit to the actual parent (which is AudioFormTree),
       * we have to emit "recursively" as well.
       */
      emitItemDragStart(node) {
        this.$emit("item-drag-start", node);
      },
      emitItemDragEnd() {
        this.$emit("item-drag-end");
      },
      emitItemDrop(node) {
        this.$emit("item-drop", node);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/typography/index.scss";
  @import "@core/preset/preset/functions.scss";

  .quiz-type-indicator {
    position: absolute;
    top: 10px;
    left: 10px;
    &--question {
      color: #63915e !important;
    }
    &--answer {
      color: #805e91 !important;
    }
    &--destination {
      color: #000 !important;
    }
  }
  .tree-item {
    padding: 45px 10px 10px 10px;
    border-radius: 5px;
    max-width: 750px;
  }

  .drag-item {
    &--dragging {
      opacity: 0.2;
    }
  }

  .actions-wrapper {
    display: flex;
    position: absolute;
    top: 10px;
    right: 10px;
    gap: 10px;
  }

  .drop-zone {
    height: 30px;
    width: 30px;
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 50%);
    border-radius: 50%;
    border: 1px dashed get-color("primary");
    background-color: get-color("primary-20");
    z-index: 9999;
    &--active {
      border: 2px solid get-color("primary");
    }
  }

  // We have to use visibility because changing DOM triggers dragAbort
  .invisible {
    visibility: hidden;
  }
</style>
